import type { ReactNode } from 'react';

import { CurrencyInput } from '#/components/CurrencyInput/CurrencyInput';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { CurrencyCode } from '#/utils/constants/currency';

import { Field } from './Field/Field';

type Props = {
  currencyCode?: CurrencyCode;
  allowDecimal?: boolean;
  description?: string;
  errorMessage?: string;
  label?: ReactNode;
  mapError?: (arg0: string) => ReactNode;
  onChange?: (newValue: string) => void;
  max?: number;
  min?: number;
  name: string;
  placeholder?: string;
  step?: number;
};

export function CurrencyInputField({
  allowDecimal,
  errorMessage,
  name,
  label,
  description,
  mapError,
  onChange,
  placeholder,
  min,
  max,
  currencyCode,
  step,
}: Props) {
  const { locale } = useI18n();
  return (
    <Field
      name={name}
      label={label}
      description={description}
      mapError={mapError}
      customCompare={() => false}
      renderInput={({ value, id, qaId, updateValue }) => (
        <CurrencyInput
          errorMessage={errorMessage}
          id={id}
          name={name}
          // TODO: Fix this the next time the file is edited.
          // oxlint-disable-next-line @typescript-eslint/no-unsafe-assignment
          value={value}
          qaId={qaId}
          onChange={(changeValue: string) => {
            updateValue(changeValue === '' ? undefined : changeValue);
            onChange?.(changeValue);
          }}
          placeholder={placeholder}
          min={min}
          max={max}
          step={step}
          currencyCode={currencyCode}
          allowDecimal={allowDecimal}
          locale={locale}
        />
      )}
    />
  );
}
